import Vue from 'vue';
import Vuex from 'vuex';

import {
  Getters,
  Mutations,
  Module,
  createStore,
  createMapper,
} from 'vuex-smart-module';

import { TranslateModule } from './modules/translate';
import { ContentModule } from './modules/content';
import { ConfigsModule } from './modules/config';
import { ConstantsModule } from './modules/constants';
import { CurrencyModule } from './modules/currency';
import { LanguageModule } from './modules/language';
import { MenuModule } from './modules/menu';
import { PaymentModule } from './modules/payment';
import { SidebarModule } from './modules/sidebar';
import { LHNJSSDKModule } from './modules/lhnJsSdk';
import { WebimModule } from './modules/webimSdk';
import { RocketChatModule } from './modules/rocketChatSdk';

Vue.use(Vuex);

class RootState {
  layout = 'default';

  onCriticalError = false;
}

class RootGetters extends Getters<RootState> {
  get layout() {
    return this.state.onCriticalError ? 'error' : this.state.layout;
  }
}

class RootMutations extends Mutations<RootState> {
  SET_LAYOUT(payload: string) {
    this.state.layout = payload;
  }

  SET_ERROR(state: boolean) {
    this.state.onCriticalError = state;
  }
}

const RootStore = new Module({
  state: RootState,
  getters: RootGetters,
  mutations: RootMutations,
  modules: {
    ContentModule,
    CurrencyModule,
    MenuModule,
    LanguageModule,
    PaymentModule,
    TranslateModule,
    ConstantsModule,
    ConfigsModule,
    SidebarModule,
    LHNJSSDKModule,
    WebimModule,
    RocketChatModule,
  },
});

export const store = createStore(
  RootStore,
  {
    strict: process.env.NODE_ENV !== 'production',
  },
);

export const RootMapper = createMapper(RootStore);
